export const PsychologistProfileRatingModalStep = {
  SELECT_RATING: 'SELECT_RATING',
  SELECT_RATING_WITH_COMMENT: 'SELECT_RATING_WITH_COMMENT',
  THANKS_FOR_GOOD_RATING: 'THANKS_FOR_GOOD_RATING'
}
